import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
} from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(8),
    maxWidth: theme.breakpoints.values.sm,
    overflow: 'hidden',
    width: '100%',
  },
}));

export const ModalWrapper = styled(DialogContent)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  padding: theme.spacing(4, 6, 6),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3, 3, 4),
  },
}));

export const ModalHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const ModalTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(32),
  fontWeight: theme.typography.fontWeightBold,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.pxToRem(24),
  },
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export const ContentContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  // padding: theme.spacing(0, 5),
}));

export const HeaderRow = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.background.default,
  borderBottom: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(3, 0),
}));

export const TableHeaderCell = styled(Typography)<{ align?: 'left' | 'right' }>(
  ({ theme, align = 'left' }) => ({
    color: theme.palette.text.secondary,
    flex: align === 'right' ? '0 0 120px' : '1 1 auto',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightMedium,
    letterSpacing: '0.08em',
    padding: theme.spacing(0.5, 0),
    textAlign: align,
    textTransform: 'uppercase',
  }),
);

export const TableBody = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const TableRow = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(3, 0),
  '&:not(:last-of-type)': {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2, 0),
  },
}));

export const TableCell = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'align' && prop !== 'positive',
})<{ align?: 'left' | 'right'; positive?: boolean }>(
  ({ theme, align = 'left', positive = false }) => ({
    color: positive ? theme.palette.success.main : theme.palette.text.primary,
    flex: align === 'right' ? '0 0 120px' : '1 1 auto',
    fontWeight:
      align === 'right'
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
    textAlign: align,
  }),
);

export const EmptyStateContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  justifyContent: 'center',
  padding: theme.spacing(6, 0),
}));

export const EmptyIconWrapper = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  height: 120,
  justifyContent: 'center',
  width: 120,
}));

export const EmptyDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightMedium,
}));

export const PaginationContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(1),
  justifyContent: 'center',
  marginTop: theme.spacing(4),
}));

export const PaginationButton = styled(IconButton)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(2),
  height: 32,
  width: 32,
}));

export const PaginationNumberButton = styled(Button)<{ active?: boolean }>(
  ({ theme, active }) => ({
    alignItems: 'center',
    // border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(2),
    color: active ? theme.palette.primary.main : theme.palette.text.primary,
    display: 'inline-flex',
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightMedium,
    height: 32,
    justifyContent: 'center',
    minWidth: 32,
    padding: 0,
    textTransform: 'none',
    backgroundColor: active
      ? theme.palette.action.selected
      : theme.palette.background.paper,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
    },
  }),
);

export const PaginationNumberLabel = styled('span')({
  lineHeight: 1,
});
